<script>
export default {
  props: {
    title: {
      type: String,
      requried: false,
      default: '',
    },

    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<template>
  <div
    @click="$emit('selected')"
    :class="[
      active ? 'bdk-border-indigo-500 hover:bdk-border-indigo-500' : 'bdk-border-gray-300 hover:bdk-border-gray-400',
    ]"
    class="bdk-relative bdk-block bdk-rounded-lg bdk-border bdk-bg-white bdk-shadow-sm bdk-px-6 bdk-py-4 bdk-cursor-pointer  sm:bdk-flex sm:bdk-justify-between focus:bdk-outline-none bdk-border-solid bdk-mt-2"
  >
    <div
      class="bdk-flex bdk-items-center bdk-flex-grow"
    >
      <div
        class="bdk-text-sm bdk-flex"
      >
        <span
          v-text="__('Template: ')"
          class="bdk-font-medium bdk-text-gray-900 bdk-block"
        />

        <span
          v-text="title"
          class="bdk-font-medium bdk-text-gray-900 bdk-block bdk-ml-1"
        />
      </div>
    </div>
  </div>
</template>
